import gql from "graphql-tag";

export const TASK_EVENT_QUERY = gql`
  query taskEventsQuery(
    $after: String
    $first: Int
    $offset: Int
    $userId: ID
    $assignedToId: ID
    $taskType_Id_In: [String]
    $taskType_Title: String
    $stage_Id_In: [String]
    $assignedToId_Isnull: Boolean
    $recentlyCompletedAndOpen: Boolean
    $assignedToId_In: [ID]
    $taskEventDate_Gte: Date
    $createdAt_Gte: DateTime
    $createdAt_Lte: DateTime
    $user_Email_Icontains: String
    $closedAt_Isnull: Boolean
    $orderBy: String
  ) {
    taskEvents(
      after: $after
      first: $first
      offset: $offset
      userId: $userId
      user_Email_Icontains: $user_Email_Icontains
      assignedToId: $assignedToId
      taskType_Id_In: $taskType_Id_In
      stage_Id_In: $stage_Id_In
      taskType_Title: $taskType_Title
      assignedToId_Isnull: $assignedToId_Isnull
      assignedToId_In: $assignedToId_In
      taskEventDate_Gte: $taskEventDate_Gte
      createdAt_Gte: $createdAt_Gte
      createdAt_Lte: $createdAt_Lte
      recentlyCompletedAndOpen: $recentlyCompletedAndOpen
      closedAt_Isnull: $closedAt_Isnull
      orderBy: $orderBy
    ) {
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
      totalCount
      edgeCount
      edges {
        node {
          id
          title
          description
          taskEventDate
          closedAt
          snoozeUntil
          createdAt
          taskeventattachmentSet {
            id
            file
          }
          stage {
            id
            isResolved
            title
          }
          taskType {
            id
            title
            priority
            tasktypesuggestionSet {
              id
              message
            }
          }
          taskeventcommentSet {
            id
            text
            user {
              id
              firstName
              lastName
            }
          }
          assignedTo {
            id
            firstName
            lastName
            userProfile {
              id
              profilePicture
            }
          }
          reporter {
            id
            firstName
            lastName
          }
          user {
            id
            firstName
            lastName
            userProfile {
              id
              profilePicture
              coachingChat {
                id
              }
            }
          }
        }
      }
    }
  }
`;

export const TASK_EVENT_REPORT_QUERY = gql`
  query taskEventsQuery($closedAt_Isnull: Boolean, $taskType_Id_In: [String], $taskType_Title: String) {
    taskEvents(taskType_Title: $taskType_Title, closedAt_Isnull: $closedAt_Isnull, taskType_Id_In: $taskType_Id_In) {
      edges {
        node {
          id
          title
          description
          taskEventDate
          closedAt
          snoozeUntil
          createdAt
          stage {
            id
            isResolved
            title
          }
          taskType {
            id
            title
            priority
          }
          assignedTo {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;

export const MY_USERS_QUERY = gql`
  query myUsersQuery(
    $assigneeId: ID!
    $taskTypes: [ID]
    $showSnoozed: Boolean
    $showAllClients: Boolean
    $corporateChallenges: [ID]
  ) {
    myUsers(
      assigneeId: $assigneeId
      taskTypes: $taskTypes
      showSnoozed: $showSnoozed
      showAllClients: $showAllClients
      corporateChallenges: $corporateChallenges
    ) {
      tasksCompleted
      tasksOutstanding
      activeClients
      tasksWithNoUser {
        id
        title
        description
        taskEventDate
        closedAt
        snoozeUntil
        createdAt
        taskeventattachmentSet {
          id
          file
        }
        stage {
          id
          isResolved
          title
        }
        taskType {
          id
          title
          priority
          tasktypesuggestionSet {
            id
            message
          }
        }
        taskeventcommentSet {
          id
          text
          user {
            id
            firstName
            lastName
          }
        }
        assignedTo {
          id
          firstName
          lastName
          userProfile {
            id
            profilePicture
          }
        }
        reporter {
          id
          firstName
          lastName
        }
        user {
          id
          firstName
          lastName
        }
      }
      users {
        id
        firstName
        lastName
        email
        userProfile {
          id
          profilePicture
          incompleteTasks
          engagementScore
          atRiskOnboarding
          activeSubscription {
            id
            product {
              id
              type
            }
            corporateChallenge {
              id
            }
            coach {
              id
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`;

export const STAGES_QUERY = gql`
  query stagesQuery {
    stages {
      id
      title
    }
  }
`;

export const TASK_TYPE_QUERY = gql`
  query taskTypesQuery {
    taskTypes {
      id
      title
    }
  }
`;

export const TASK_COMMENTS_QUERY = gql`
  query taskComments($taskId: ID) {
    taskComments(taskEventId: $taskId) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          id
          text
          createdAt
          user {
            id
            firstName
            lastName
            userProfile {
              id
              profilePicture
            }
          }
        }
      }
    }
  }
`;

export const TASK_EVENT_BY_ID_QUERY = gql`
  query taskEvent($taskEventId: ID!) {
    taskEvent(taskEventId: $taskEventId) {
      id
      title
      description
      taskEventDate
      closedAt
      snoozeUntil
      createdAt
      taskeventattachmentSet {
        id
        file
      }
      stage {
        id
        isResolved
        title
      }
      taskType {
        id
        title
        priority
        tasktypesuggestionSet {
          id
          message
        }
      }
      taskeventcommentSet {
        id
        text
        user {
          id
          firstName
          lastName
        }
      }
      assignedTo {
        id
        firstName
        lastName
        userProfile {
          id
          profilePicture
        }
      }
      reporter {
        id
        firstName
        lastName
      }
      user {
        id
        firstName
        lastName
      }
    }
  }
`;

export const TASK_REPORT_QUERY = gql`
  query taskEventReport {
    taskEventReport {
      report {
        data
      }
    }
  }
`;
